import React from 'react';

import './Panel.scss';

/**Stylized div container
 * @param {object} props Incoming JSX attributes.
 * @param {object} [props.classes] An array of class strings to be concatenated with the default Panel component strings for style/functional targeting of the component. Defaults to an empty array.
 * @param {object} props.children The children of a Panel component should be the contents to display within the bordered panel. Most often it is a number of PanelSection components, each containing a section's view of elements.
 * @returns {JSX.Element} Stylized div container
 * @see {@link https://bitbucket.org/pcgeducation/shipyard/src/master/shipyard-web/src/components/shared/Panel.md Panel Documentation} for further information
 */

function Panel(props) {
    const classes = props.classes ? props.classes : [];
    const classString = classes.concat(['panel']).join(' ');

    return <div className={classString}>{props.children}</div>;
}

export default Panel;
